import React from 'react';
type Props = {
  style?: React.CSSProperties;
  className?: string;
};

const SubText: React.FC<Props> = ({ children, style, className }) => (
  <span
    style={{ fontWeight: 400, color: '#757575', fontSize: '18px', ...style }}
    className={className}
  >
    {children}
  </span>
);

export default SubText;
